module.exports = __webpack_public_path__ + "img/categorie-huitres-famille-boutrais.b2df2d3d.webp";